import * as ActionTypes from '../constants';
import { baseUrl } from './../index';
// import { AsyncStorage } from 'react-native';
import axios from 'axios';
import { getUserToken } from './../getUserToken';


export default function(state={}, action) {
    switch(action.type) {
        case ActionTypes.REQUEST_GET_SOURCE_FILES_WITH_JW_MEDIA_ID : 
            return {
                ...state,
                loading: true,
                error:false,
                errInfo: null, 
                response: null
            }
        case ActionTypes.RECEIVED_GET_SOURCE_FILES_WITH_JW_MEDIA_ID : 
            return {
                ...state,
                loading: false,
                response: action.res,
                error: false,
                errInfo: null
            }
        case ActionTypes.ERROR_GET_SOURCE_FILES_WITH_JW_MEDIA_ID: 
            return {
                ...state,
                loading: false,
                error: true,
                errInfo: action.err,
                response: null
            }
        case ActionTypes.CLEAR_GET_SOURCE_FILES_WITH_JW_MEDIA_ID: 
            return { }
        default :  return state
    }

}

 


const dispatchRequestGetJwPlayerSourceFiles = () => ({
    type:ActionTypes.REQUEST_GET_SOURCE_FILES_WITH_JW_MEDIA_ID,
    
})

const dispatchReceivedGetJwPlayerSourceFiles = res =>({
    type:ActionTypes.RECEIVED_GET_SOURCE_FILES_WITH_JW_MEDIA_ID,
    res
})

const dispatchErrorGetJwPlayerSourceFiles = (err) => ({
    type:ActionTypes.ERROR_GET_SOURCE_FILES_WITH_JW_MEDIA_ID,
    err
})

const dispatchClearGetJwPlayerSourceFiles= () => ({
    type: ActionTypes.CLEAR_GET_SOURCE_FILES_WITH_JW_MEDIA_ID
})

export const clearGetJwPlayerSourceFiles = () => dispatchClearGetJwPlayerSourceFiles();

export const getGetJwPlayerSourceFiles = (mediaId) => dispatch => {

    dispatch(dispatchRequestGetJwPlayerSourceFiles());   

    // const data = {course_id: courseId};

    getUserToken()
        .then( authKey => {
            const options = {
                method: 'get',
                url: `https://cdn.jwplayer.com/v2/media/${mediaId}`,
                // headers: {
                //     'Authorization': `Bearer ${authKey}`
                // }
            }
            return axios(options)
                .then(({data}) => {
                    dispatch(dispatchReceivedGetJwPlayerSourceFiles(data))
                })
        })
        .catch(e => dispatch(dispatchErrorGetJwPlayerSourceFiles(e)));    
}
